export type GetDeepProp<T extends Record<string, unknown>, K extends string> = K extends keyof T
    ? T[K]
    : { [P in keyof T]: GetDeepProp<Extract<T[P], Record<string, unknown>>, K> }[keyof T];

// eslint-disable-next-line no-shadow
export enum RoutePath {
    HOME = "/",
    Dashboard = "/dashboard",
}
